import React from 'react';
import { Card } from '../ui/Card';
import { AdminAstrologer } from '../../data/adminMockData';
interface AdminProfilesManagerProps {
  astrologers: AdminAstrologer[];
  renderStatusBadge: (status: string) => React.ReactNode;
  renderTableHeader: (title: string, count: number, onExport?: () => void) => React.ReactNode;
  generateCSV: (data: any[], name: string) => void;
}
export function AdminProfilesManager({
  astrologers,
  renderStatusBadge,
  renderTableHeader,
  generateCSV
}: AdminProfilesManagerProps) {
  return <div className="space-y-4" data-id="element-6892">
      {renderTableHeader('Профили астрологов', astrologers.length, () => generateCSV(astrologers, 'profiles'))}
      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-6893">
        <table className="w-full text-left" data-id="element-6894">
          <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-6895">
            <tr data-id="element-6896">
              <th className="px-3 py-2" data-id="element-6897">Астролог</th>
              <th className="px-3 py-2" data-id="element-6898">Специализация</th>
              <th className="px-3 py-2" data-id="element-6899">Рейтинг</th>
              <th className="px-3 py-2" data-id="element-6900">Статус</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-6901">
            {astrologers.map(a => <tr key={a.id} className="hover:bg-slate-50" data-id="element-6902">
                <td className="px-3 py-2 text-sm font-medium" data-id="element-6903">{a.name}</td>
                <td className="px-3 py-2 text-xs text-slate-500" data-id="element-6904">{a.spec}</td>
                <td className="px-3 py-2 text-sm" data-id="element-6905">⭐ {a.rating}</td>
                <td className="px-3 py-2" data-id="element-6906">{renderStatusBadge(a.status)}</td>
              </tr>)}
          </tbody>
        </table>
      </Card>
    </div>;
}